/**
 * Logged-in website user (Customer record + linked system User fields).
 * Prefers `user`, falls back to legacy `customer` key.
 */
export function getLoggedInUser() {
  if (typeof window === "undefined") return null;

  try {
    const raw =
      localStorage.getItem("user") || localStorage.getItem("customer");
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== "object") return null;
    return data;
  } catch {
    return null;
  }
}

export function getLoggedInCustomerId() {
  const user = getLoggedInUser();
  return user?.id ?? null;
}
